import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/modules/auth';

@Component({
  selector: 'app-filters-modal',
  templateUrl: './filters-modal.component.html',
})
export class FiltersModalComponent {
  @Input() filters: any;
  @Input() campaignModule: string | null = '';
  @Output() filtersChanged = new EventEmitter<any>();

  constructor(public activeModal: NgbActiveModal, public authService: AuthService) {}

  // Method to apply the filters
  applyFilters(): void {
    this.filtersChanged.emit(this.filters);
    this.activeModal.close(this.filters);
  }

  // Method to close the modal without applying filters
  close(): void {
    this.activeModal.dismiss();
  }

  // Method to reset the filters to their default state
  resetFilters(): void {
    this.filters = {
      showID: false,
      showType: true,
      showCreated: true,
      showModified: false,
      showCalledAt: true,
      showStatus: true,
      showPhone: true,
      showDuration: true,
      showAttempts: true,
      showScheduled: false,
      showQuickActions: false,
      showEliotID: false,
      showEliotName: false,
      showEliotSurname: false,
      showEliotCompany: false,
      showEliotLink: false,
      showEliotSync: false,
      showEliotSyncDate: false,
      showContactCampaignFrom: false,
      showContactEmail: false,
      showContactJobFor: false,
      showContactLanguageGrade: false,
      showContactName: false,
      showContactSource: false,
      showContactSubmit: false,
      showContactSurname: false,
    };
    // Emit the reset filters if necessary
    this.filtersChanged.emit(this.filters);
  }
}
